import { Reveal } from "./Reveal";

export default function CustomSection({ section }) {
  return (
    <section className="py-24 lg:py-32 bg-[var(--c-bg)] paper-texture">
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <Reveal>
          {section.heading && (
            <h2 className="font-heading font-bold text-[var(--c-primary)] text-3xl sm:text-4xl lg:text-5xl text-center mb-10">{section.heading}</h2>
          )}
          <div
            className="prose prose-stone max-w-none font-body text-[var(--c-text)]/90 [&_h2]:font-heading [&_h2]:text-[var(--c-primary)] [&_h3]:font-heading [&_blockquote]:border-l-4 [&_blockquote]:border-[var(--c-accent)] [&_blockquote]:pl-4 [&_blockquote]:italic [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:list-decimal [&_ol]:pl-6 [&_a]:text-[var(--c-secondary)]"
            dangerouslySetInnerHTML={{ __html: section.html || "" }}
          />
        </Reveal>
      </div>
    </section>
  );
}
